"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _app = require("@package/app");

var _storybook = require("@pikassa/storybook");

var _react = _interopRequireWildcard(require("react"));

var _defaultModule = _interopRequireDefault(require("./default.module.scss"));

function hidePartEmail() {
  var email = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var regExp = /([\w.-]+)@(\w+)/g;
  return email.replace(regExp, function (value, part1, part2) {
    var replace = part1.replace(/^(\w)|[\w.-]/g, '$1*');
    return "".concat(replace, "@").concat(part2);
  });
}

function Security(_ref) {
  var onLoaded = _ref.onLoaded,
      onChange = _ref.onChange,
      onConfirm = _ref.onConfirm,
      inProcess = _ref.inProcess,
      editable = _ref.editable,
      data = _ref.data;

  try {
    var normalizeData = function normalizeData() {
      return {
        email: {
          isConfirm: data['emailConfirmed'],
          value: hidePartEmail(data['email'])
        }
      };
    };

    var onChangeEmail = function onChangeEmail() {
      onChange && onChange('email.change');
    };

    var onConfirmEmail = function onConfirmEmail() {
      onConfirm && onConfirm();
    };

    (0, _react.useEffect)(function () {
      onLoaded && onLoaded();
    }, []);

    var _normalizeData = normalizeData(),
        email = _normalizeData.email;

    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['block'],
      "data-locator": "options.security"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['block__title']
    }, /*#__PURE__*/_react["default"].createElement(_storybook.Text, {
      type: 'section'
    }, "\u0411\u0435\u0437\u043E\u043F\u0430\u0441\u043D\u043E\u0441\u0442\u044C")), /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['block__content']
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['block__column']
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['block__field-title']
    }, "\u041A\u043E\u043D\u0442\u0430\u043A\u0442\u044B \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F"), /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['field']
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['field__label']
    }, "Email"), /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['field__content']
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['part']
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['part__content']
    }, /*#__PURE__*/_react["default"].createElement(_storybook.Input, {
      disabled: true,
      value: email['value']
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['part__controls']
    }, !email['isConfirm'] && /*#__PURE__*/_react["default"].createElement(_storybook.Button, {
      "data-locator": 'option.email.confirm',
      type: 'submit',
      mode: 'primary',
      inProcess: inProcess,
      disabled: !editable,
      onClick: onConfirmEmail
    }, "\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u044C"), /*#__PURE__*/_react["default"].createElement(_storybook.Button, {
      "data-locator": 'option.email.change',
      type: 'submit',
      form: 'outline',
      mode: 'primary',
      disabled: inProcess || !editable,
      onClick: onChangeEmail
    }, "\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C")), !email['isConfirm'] && /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['status'],
      "data-locator": "option.email.status"
    }, /*#__PURE__*/_react["default"].createElement(_storybook.Text, {
      className: _defaultModule["default"]['status__value'],
      "data-locator": "option.email.status.value"
    }, "! \u041D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u043E \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u044C email"))))))));
  } catch (e) {
    return /*#__PURE__*/_react["default"].createElement(_app.Error, {
      error: e
    });
  }
}

var _default = Security;
exports["default"] = _default;